import { DealParams } from 'app/models/deal-params'
import HoldIndicator, { holdsToEntries } from './hold-indicator'

// Deal-hold indicator: the shared origin-aware hold card wired for a deal's flat
// `holds` list. Display-only — a Signing Portal deal hold is placed and lifted
// in the Signing Portal, so LendOS shows the read-only card and offers no lift
// (makeLift always returns undefined). Renders nothing when the deal has no
// active hold.
export default function DealHoldIndicator({ deal }: { deal?: DealParams }) {
  if (!deal) return null

  const entries = holdsToEntries(deal.holds ?? [], 'Deal', () => undefined)

  if (entries.length === 0) return null

  return (
    // Stops clicks inside the indicator from bubbling to a clickable table row.
    <span style={{ display: 'inline-flex' }} onClick={e => e.stopPropagation()}>
      <HoldIndicator
        holds={entries}
        variant="auto"
        interaction="click"
        // Accordion (one panel open, the rest collapsed headers) only when there
        // is more than one lock/hold to show — matching the Trades card; a single
        // one renders plainly.
        layout={entries.length > 1 ? 'accordion' : 'stacked'}
        ariaLabel="Deal hold status"
        size={24}
      />
    </span>
  )
}
